<template>
    <div>
        <el-form size="mini" label-position="top">
            <el-card>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="ID">{{ detail.id }}</el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item v-if="!edit" label="标题">{{ detail.name }}</el-form-item>
                        <el-form-item v-else label="标题">
                            <el-input v-model="detail.name"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="封面">
                            <img style="height: 200px;" :src="detail.coverUrl" alt="">
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="设备">{{ detail.productName }}</el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="电池（数量）">{{ detail.batteryName }} * {{ detail.batteryCount
                        }}组</el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="站点">{{ detail.siteName }}</el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="点赞量">{{ detail.likeCount }}</el-form-item>
                    </el-col>
                </el-row>
                <el-form-item label="解决方案URL">{{ detail.pageUrl }}</el-form-item>
            </el-card>
            <el-card style="margin-top: 10px;">
                <el-row>
                    <el-col :span="8">
                        <el-form-item v-if="!edit" label="分类">
                            {{ detail.categoryName }}
                        </el-form-item>
                        <el-form-item v-else label="分类">
                            <el-select v-model="detail.categoryName">
                                <el-option v-for="item in categoryList" :key="item.id" :value="item.id"
                                    :label="item.name"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="通过时间">
                            {{ dayjs(detail.approveTime).format('YYYY-MM-DD HH:mm') }}
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="上下架状态">
                            {{ detail.shelfStatus == 1 ? '上架' : '下架' }}
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-card>
            <div style="display: flex;justify-content: flex-end;margin-top: 20px">
                <el-button @click="$router.back()">返回</el-button>
                <el-button v-if="!edit" type="primary" @click="edit = true">编辑详情</el-button>
                <el-button v-else type="primary" @click="handleSave">保存更改</el-button>
            </div>
        </el-form>
    </div>
</template>
<script>
import { detail, categoryList, edit } from "@/api/solution"
import dayjs from "dayjs"
export default {
    data() {
        return {
            detail: {},
            id: "",
            dayjs,
            edit: false,
            categoryList: []
        }
    },
    mounted() {
        this.id = this.$route.query.id;
        this.getDetail();
        this.getCategoryList();
    },
    methods: {
        getDetail() {
            detail(this.id).then(({ code, data, message }) => {
                if (code == 200) {
                    this.detail = data;
                } else {
                    this.$message.error(message);
                }
            })
        },
        getCategoryList() {
            categoryList().then(({ code, data, message }) => {
                if (code == 200) {
                    this.categoryList = data;
                } else {
                    this.$message.error(message);
                }
            })
        },
        handleSave() {
            edit(this.detail).then(({ code, message }) => {
                if (code == 200) {
                    this.$message.success("保存成功");
                    this.getDetail();
                    this.edit = false;
                } else {
                    this.$message.error(message);
                }
            })
        }
    }
}
</script>